import {Component, Input} from '@angular/core';
import {TranslationValue} from '../../generated/sales-terminal-client';

export interface TotalsTable {
  header?: TotalsTableItem[];
  body?: TotalsTableItem[];
  footer?: TotalsTableItem[];
}
export interface TotalsTableItem {
  label?: string | TranslationValue[];
  title?: string | TranslationValue[];
  value?: number;
  subValue?: string;
  type?: 'amount' | 'price' | 'no-value';
  useDash?: boolean;
  isPrefix?: boolean;
}

@Component({
  selector: 'app-totals-table',
  templateUrl: './totals-table.component.html',
  styleUrls: ['./totals-table.component.scss']
})
export class TotalsTableComponent {
  @Input() public tableData: TotalsTable;
}
